import { PrinterOutlined } from "@ant-design/icons";
import { Button, message, Spin } from "antd";
import { useEffect, useState } from "react";
import { AppLogoIcon } from "components/svg-icons";
import NotFoundPage from "pages/not-found";
import { PrintViewLayoutState } from "./model";
import CustomReportPrintView from "./custom-report-print-view";
import MaterialLogPrintView from "./material-log-print-view";
import SubmittalLogPrintView from "./submittal-log-print-view";
import BidPackageLogPrintView from "./bid-package-log-print-view";
import ActivityLogPrintView from "./activity-log-print-view";
import PlannerPrintView from "./planner-print-view";
import DesignScopeLogPrintView from "./design-scope-log-print-view";
import DesignScopeCatalogPrintView from "./design-scope-catalog-print-view";
import { consumePrintViewState } from "./print-view-storage";

function PrintViewLayout() {
  const [state, setState] = useState<PrintViewLayoutState | null>(null);
  const [isPageNotFound, setIsPageNotFound] = useState(false);

  useEffect(() => {
    const parsed = consumePrintViewState();
    if (parsed) {
      setIsPageNotFound(false);
      setState(parsed);
    } else {
      setIsPageNotFound(true);
      message.error("No state found");
    }
  }, []);

  if (isPageNotFound) {
    return <NotFoundPage />;
  }

  if (!state) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin description="Loading..." size="large" />
      </div>
    );
  }

  return (
    <div className="p-3">
      <div className="fixed bottom-5 right-5 p-4 z-40 print:hidden">
        <Button
          type="primary"
          shape="circle"
          size="large"
          onClick={() => {
            window.print();
          }}
          icon={<PrinterOutlined />}
          className="print:hidden"
          data-testid="print-button"
        />
      </div>
      <div className="flex gap-6 px-1 pb-4 pt-1">
        <div className="w-[120px] flex">
          <AppLogoIcon />
        </div>
        <div className="text-xl font-bold">{state.title}</div>
      </div>
      {state.pageId === "custom-material-report" && (
        <CustomReportPrintView state={state} />
      )}
      {state.pageId === "material-log" && (
        <MaterialLogPrintView state={state} />
      )}
      {state.pageId === "submittal-log" && (
        <SubmittalLogPrintView state={state} />
      )}
      {state.pageId === "bid-package-log" && (
        <BidPackageLogPrintView state={state} />
      )}
      {state.pageId === "activity-log" && (
        <ActivityLogPrintView state={state} />
      )}
      {state.pageId === "design-package-planner" && (
        <PlannerPrintView state={state} />
      )}
      {state.pageId === "design-scope-log" && (
        <DesignScopeLogPrintView state={state} />
      )}
      {state.pageId === "design-scope-catalog" && (
        <DesignScopeCatalogPrintView state={state} />
      )}
    </div>
  );
}

export default PrintViewLayout;
